import CustomSwiper from "@/components/Swiper/CustomSwiper";
import CustomSwiperSlide from "@/components/Swiper/CustomSwiperSlide";
import TeamBoardCard from "./components/TeamBoardCard";
import { useMediaQuery } from "@react-hook/media-query";
import { useEffect, useState } from "react";

export default function TeamBoard({ directors }) {
  const md = useMediaQuery("(max-width: 992px)");
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(md);
  }, [md]);

  return (
    <div className="container pt-[50px] lg:pt-[86px]">
      <div className="flex justify-center flex-col gap-[18px]">
        <div className="flex justify-center gap-5 flex-wrap max-w-[760px] mx-auto">
          <h5 className="text-3xl/[42px]">
            Board of Directors & Operational Support
          </h5>
        </div>
      </div>
      {isMobile ? (
        <div className="pt-10">
          <CustomSwiper
            view={{ desktop: 1, laptop: 1, md: 1, mobile: 1 }}
            space={14}
            containerStyles="max-w-full"
            navigate={true}
          >
            {directors.map(({ id, name, position, image }) => (
              <CustomSwiperSlide key={id}>
                <TeamBoardCard name={name} position={position} image={image} />
              </CustomSwiperSlide>
            ))}
          </CustomSwiper>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-[14px] gap-y-[70px] py-10 sm:pt-[74px] sm:pb-[78px]">
          {directors.map(({ id, name, position, image }) => (
            <TeamBoardCard
              key={id}
              name={name}
              position={position}
              image={image}
            />
          ))}
        </div>
      )}
    </div>
  );
}
